import { Table, TD, TH, TR } from '@ag-media/react-pdf-table';
import { Image, Page, Text, View } from '@react-pdf/renderer';
import { Map } from '~/components/Map';
import QrCode from '~/components/QrCode';

export const COMPONENTS = {
  Page: Page,
  View: View,
  Text: Text,
  Image: Image,
  Table: Table,
  TH: TH,
  TR: TR,
  TD: TD,
  QrCode: QrCode,
  Map: Map,
};
